import { setCookieStorage } from '../utils/CookieLocalStorage';

export const getUnixTimeStamp = () => {
    return Math.floor(new Date().getTime() / 1000);
};

export const userLogout = (props) => {
    let deleteSessionTokenCookie = setCookieStorage('session_token', null, { path: '/', sameSite: true });
    if (deleteSessionTokenCookie && props.history) {
        return props.history.push('/auth/login');
    }
    else if (!props.success && props.message_code === 30001) {
        // message_code 10001 determined the session token is unauthorized or it expired
        window.location.assign('/auth/login?sessexpire=true');
    }

    // usersLogoutAPI().then((res) => {
    //     if(res.success &&res.message_code === 2150){
    //         let deleteSessionTokenCookie = setCookieStorage('session_token', null, { path: '/', sameSite: true });
    //         if (deleteSessionTokenCookie && props.history) {
    //             return props.history.push('/auth/login');
    // }
    //     }
    //     else if (!props.success && props.message_code === 10001) {
    //         // message_code 10001 determined the session token is unauthorized or it expired
    //         window.location.assign('/auth/login?sessexpire=true');
    //     }
    // })

}